export default __webpack_public_path__ + "static/media/android.7a6c7451.svg";